const config = {
    API_KEY: "AIzaSyDJxHGhc8bqjfluv2M2z05WpBD3jpDRs7A",
    AUTH_DOMAIN: "serenes.firebaseapp.com",
    PROJECT_ID: "serenes",
    STORAGE_BUCKET: "serenes.appspot.com",
    MESSAGING_SENDER_ID: "1057359758485",
    APP_ID: "1:1057359758485:web:bbb4732753b4359419879c",
    MEASUREMENT_ID: "G-XFNB99KKNV",
}

export default config;